import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { Subject, takeUntil } from 'rxjs';
import { TrendGraphSocketCommands } from 'ops/common/io-event/websocket-message';
import { TrendGraphAccessEvents } from 'ops/common/models/access-settings';

@Injectable({ providedIn: 'root' })
export class TrendGraphSocketService {
    destroySubscriptions$: Subject<void> = new Subject();
    updateViewsList$: Subject<void> = new Subject<void>();

    constructor(private socketService: SocketMiddlewareService) {}

    startSubscriptions() {
        this.subscribeToEvent(this.trendGraphCreated());
        this.subscribeToEvent(this.trendGraphDeleted());
        this.subscribeToEvent(this.trendGraphUpdated());
        this.subscribeToEvent(this.accessSettingsUpdated());
    }

    private subscribeToEvent(event$) {
        event$.pipe(takeUntil(this.destroySubscriptions$)).subscribe(() => {
            this.updateViewsList$.next();
        });
    }

    destroySubscriptions() {
        this.destroySubscriptions$.next();
        this.destroySubscriptions$.complete();
    }

    updateViewsSubject(): Subject<void> {
        return this.updateViewsList$;
    }

    trendGraphCreated() {
        return this.socketService.receiveMessageObserver(TrendGraphSocketCommands.GRAPH_CREATED);
    }

    trendGraphDeleted() {
        return this.socketService.receiveMessageObserver(TrendGraphSocketCommands.GRAPH_DELETED);
    }

    trendGraphUpdated() {
        return this.socketService.receiveMessageObserver(TrendGraphSocketCommands.GRAPH_UPDATED);
    }

    accessSettingsUpdated() {
        return this.socketService.receiveMessageObserver(
            TrendGraphAccessEvents.TrendGraphAccessUpdated,
        );
    }
}
